import { processNodes } from "react-html-parser";
import action from "../action";
import { setIsLoading } from "../loader/action";
import store from "../store";
export const SET_ROOM = "SET_ROOM";
export const SET_EMOJI = "SET_EMOJI";
export const SET_MAILCHIMP_ID = "SET_MAILCHIMP_ID";
export const END_GAME = "END_GAME";
export const RE_CONNECT = "RE-CONNECT";
export const SET_GAME_NAME = "SET_GAME_NAME";
export const SET_MY_TEAM_USERS = "SET_MY_TEAM_USERS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_HOW_TO_PLAY = "SET_HOW_TO_PLAY";
export const SET_SESSION = "SET_SESSION";
export const SET_SESSION_ID = "SET_SESSION_ID";
export const SET_SESSION_LINK = "SET_SESSION_LINK";
export const SET_WELLNESS_PARAMS_OBJECT = "SET_WELLNESS_PARAMS_OBJECT";
export const SET_MAGIC_LINK_DATA = "SET_MAGIC_LINK_DATA";
export const SET_TEAM_CHALLENGES = "SET_TEAM_CHALLENGES";
export const SET_INGAME_CHANGE_TEAM_STATE = "SET_INGAME_CHANGE_TEAM_STATE";
export const SET_VIEW_ACTIVITY = "SET_VIEW_ACTIVITY";

let paramApiUrl = process.env.REACT_APP_PARAMETER_API;

export const setMailchimpId = (data) =>
  action({
    type: SET_MAILCHIMP_ID,
    data
  });
export const setSessionLink = (data) =>
  action({
    type: SET_SESSION_LINK,
    data
  });
export const setWellnessParamsOnject = (data) =>
  action({
    type: "SET_WELLNESS_PARAMS_OBJECT",
    data
  });
export const setEmoji = (data) =>
  action({
    type: SET_EMOJI,
    data
  });
export const setRoom = (data) =>
  action({
    type: SET_ROOM,
    data
  });
export const setSession = (data) =>
  action({
    type: SET_SESSION,
    data
  });
export const setGameName = (data) =>
  action({
    type: SET_GAME_NAME,
    data
  });

export const set_session_id = (data) =>
  action({
    type: SET_SESSION_ID,
    data
  });

export const getAllGames = () =>
  action({
    type: "GET_GAMES",
    payload: {
      request: {
        url: `${paramApiUrl}/games`,
        method: "GET"
      }
    }
  });

export const setUserClues = (data) =>
  action({
    type: "SET_USER_CLUES",
    data
  });

export const endGame = (data) =>
  action({
    type: END_GAME,
    data
  });

export const setCurrentUser = (data) =>
  action({
    type: SET_CURRENT_USER,
    data
  });

export const setFlippedCard = (data) =>
  action({
    type: "SET_FLIPPED_CARD",
    data
  });

export const setPlayerCards = (data) =>
  action({
    type: "SET_PLAYER_CARDS",
    data
  });
export const setTeamChallenges = (data) =>
  action({
    type: "SET_TEAM_CHALLENGES",
    data
  });
export const setMagicLinkData = (data) =>
  action({
    type: "SET_MAGIC_LINK_DATA",
    data
  });
export const setInGameChangeTeamState = (data) =>
  action({
    type: "SET_INGAME_CHANGE_TEAM_STATE",
    data
  });
export const set_view_activity = (data) =>
  action({
    type: "SET_VIEW_ACTIVITY",
    data
  });
